/// <amd-module name="Wit/WorkItems/Redux/Selectors" />

import { IWorkItemAwareState, IWorkItemChange } from "Wit/WorkItems/WorkItemContracts";
import { getWorkItem } from "Wit/WorkItems/WorkItemSelectors";

export function getPendingWorkItemChanges(state: IWorkItemAwareState, workItemId: number): IWorkItemChange[] | undefined {
    const workItem = getWorkItem(state, workItemId);
    return workItem && workItem.pendingChanges;
}

export function getNextPendingWorkItemChange(state: IWorkItemAwareState, workItemId: number): IWorkItemChange | undefined {
    const pendingChanges = getPendingWorkItemChanges(state, workItemId);

    if (pendingChanges && pendingChanges.length > 0) {
        return pendingChanges[0];
    }

    return undefined;
}
